import { render, staticRenderFns } from "./shortAnswerSubject.vue?vue&type=template&id=3505b85d&scoped=true"
import script from "./shortAnswerSubject.vue?vue&type=script&lang=js"
export * from "./shortAnswerSubject.vue?vue&type=script&lang=js"
import style0 from "./shortAnswerSubject.vue?vue&type=style&index=0&id=3505b85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505b85d",
  null
  
)

export default component.exports